export default __webpack_public_path__ + "static/media/woman-update.f21f6713.svg";